import type {Positions} from './types';
import {AX,EQW} from '../content/axes';
import {PARTIES} from '../content/parties';
import {S} from './state';
import {clamp} from './util';

/** Partei, die gerade auf dem Kanzler-Platz sitzt, unter ihrer eigenen Kennung ansprechen (Mehrspieler). */
const al=(id:string):string=>(S&&S.mp&&S.mp.mode==='versus'&&(S.mp as any).ai===id&&!PARTIES[id])?'YOU':id;
export const PN=(id:string):string=>(id=al(id))==='YOU'?S.name:PARTIES[id].n;
export const PA=(id:string):string=>(id=al(id))==='YOU'?(S.abbr||abbr(S.name)):PARTIES[id].a;
export const PC=(id:string):string=>(id=al(id))==='YOU'?(S.color||'var(--accent)'):PARTIES[id].c;
export function abbr(n?:any){const w=n.trim().split(/\s+/).filter(Boolean);return (w.length>1?w.map((x:any)=>x[0]).join(''):n.slice(0,3)).toUpperCase().slice(0,4)||'DU'}
export const posOf=(id:string):Positions=>(id=al(id))==='YOU'?S.you:PARTIES[id].pos;
export const wOf=(id:string):Positions=>(id=al(id))==='YOU'?(S.youW||EQW):PARTIES[id].w;
export function lr(id?:any){const p=posOf(id);return p.sicherheit-p.sozial-p.klima-p.migration-p.haushalt+(id==='HO'?3:0)+(id==='LR'?-.5:0)}

export function satWith(id?:any,vals?:any){const p=posOf(id),w=wOf(id);let n=0,d=0;for(const a of AX){n+=w[a]*Math.abs(vals[a]-p[a]);d+=w[a]}return 1-n/(4*d)}
export function scoreRaw(pos?:any,w?:any,lp?:any){let n=0,d=0;for(const a in lp){n+=(w[a]||1)*Math.abs(clamp(lp[a],-2,2)-(pos[a]??0));d+=(w[a]||1)}return d?1-n/(4*d):.6}
export function score(id?:any,lp?:any){const p=posOf(id),w=wOf(id);let n=0,d=0;
  for(const a in lp){let pv=p[a];if(S.agree&&S.partners.includes(id))pv=.4*pv+.6*S.agree[a];n+=w[a]*Math.abs(clamp(lp[a],-2,2)-pv);d+=w[a]}
  return d?1-n/(4*d):.6}
